<template>
  <div class="card-base hil-root" id="hp-incident">
    <h4 class="card-title mb-0 text-ellipsis">{{ $t("homePage.incidentTicketsTitle") }}</h4>
    <p class="text-sm text-gray m-0 mt-1 line-clamp-2">{{ $t("homePage.incidentTicketsSub") }}</p>
    <div class="flex flex-wrap gap-2 mt-3">
      <GradientButton
        v-for="(link, index) in links"
        :key="index"
        :to="link.to"
        :label="link.label"
        :title="link.label"
        custom-class="hil-btn text-ellipsis"
      />
    </div>
  </div>
</template>

<script setup>
import GradientButton from "@/components/Primitives/Buttons/GradientButton.vue";

defineProps({
  links: {
    type: Array,
    default: () => [],
    validator: (v) => v.every((l) => "label" in l && "to" in l),
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.hil-root {
  padding: 20px 24px;
}

.hil-btn {
  flex: 0 0 calc(33.333% - 6px);
  min-width: 0;
  box-sizing: border-box;
}

@media screen and (max-width: $breakpoint-tablet) {
  .hil-btn {
    flex: none;
    width: 100%;
    text-align: center;
  }
}
</style>